import { editSelf } from 'actions'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { formatPhoneNumber, phoneValRegex } from 'utils/helpers'

import styles from './UpdateSelfPhone.module.scss'

const UpdateSelfPhone = () => {
  const dispatch = useDispatch()
  const userEmail = useSelector(s => s.login.currentUser.email)

  function handleChangePhone(e) {
    setInputValue(formatPhoneNumber(e.target.value))
  }

  const [inputValue, setInputValue] = useState('')

  return (
    <div>
      <TextInput
        width="100%"
        className={styles.input}
        type={'tel'}
        label={''}
        value={inputValue}
        onChange={handleChangePhone}
        autoFocus={true}
        pattern={phoneValRegex}
        placeholder="(555) 555-5555"
        required
      />
      <button
        disabled={!inputValue.match(phoneValRegex)}
        onClick={() =>
          dispatch(
            editSelf({
              phone: `+1${inputValue.replace(/[^0-9.]/g, '')}`,
              email: userEmail
            })
          )
        }
        className={styles.loginButton}
      >
        Continue
      </button>
    </div>
  )
}

export default UpdateSelfPhone
